const AGREEMENT_STORAGE_KEY = "shaku_terms_accepted";

interface AgreementData {
  acceptedAt: string;
}

// Check if user has accepted Terms & Conditions (only for logged-in users)
export const hasAcceptedAgreement = (): boolean => {
  // Check if user is logged in (has token)
  const token = localStorage.getItem("token");
  if (!token) {
    // Not logged in, always show agreement
    return false;
  }

  // User is logged in, check if they've accepted before
  try {
    const stored = localStorage.getItem(AGREEMENT_STORAGE_KEY);
    if (!stored) return false;

    const data: AgreementData = JSON.parse(stored);
    return !!data.acceptedAt;
  } catch {
    return false;
  }
};

export const acceptAgreement = (): void => {
  // Only save if user is logged in
  const token = localStorage.getItem("token");
  if (!token) {
    return;
  }

  const now = new Date();
  const data: AgreementData = {
    acceptedAt: now.toISOString(),
  };

  localStorage.setItem(AGREEMENT_STORAGE_KEY, JSON.stringify(data));
};

export const clearAgreement = (): void => {
  localStorage.removeItem(AGREEMENT_STORAGE_KEY);
};
